
export class ErpDictionary{
    static CRAFT_TYPE_ALGO=1;
    static CRAFT_TYPE_CRAFT=2;
    static CRAFT_TYPE_NONE=3;
}
export class ErpSource{
    static CraftTypeSource=[
        {value:ErpDictionary.CRAFT_TYPE_ALGO,text:'算法'},
        {value:ErpDictionary.CRAFT_TYPE_CRAFT,text:'工艺'},
        {value:ErpDictionary.CRAFT_TYPE_NONE,text:'无'}
    ]
}